var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{on:{"click":_vm.openModal}},[_c('em',{staticClass:"fas fa-sticky-note postit"})]),_vm._v(" "),_c('note-modal',{attrs:{"show-modal":_vm.showModal},on:{"close-modal":_vm.closeModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }